import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  output,
} from '@angular/core';
import type { UntypedFormGroup } from '@angular/forms';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslatePipe } from '@recruitee/i18n';

import { ButtonComponent } from '../../common/button/components/button/button.component';
import { ButtonLoadingDirective } from '../../common/button/directives/button-loading/button-loading.directive';
import { GroupComponent } from '../../common/group/group.component';
import { InputComponent } from '../../forms/input/input.component';

@Component({
  selector: 'rt-list-sortable-form',
  templateUrl: './list-sortable-form.component.html',
  styleUrls: ['./list-sortable-form.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ButtonLoadingDirective,
    GroupComponent,
    InputComponent,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class ListSortableFormComponent implements OnInit {
  @Input() public value: string;
  @Input() public processing: boolean = false;
  public saveClick = output<string>();
  public cancelClick = output<void>();

  public nameForm: UntypedFormGroup;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.nameForm = this.formBuilder.group({
      name: [this.value, Validators.required],
    });
    this.nameForm.valueChanges
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(() => this.cdRef.detectChanges());
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public save(): void {
    if (!this.nameForm.valid || this.nameForm.get('name')!.value === this.value) {
      return;
    }

    this.processing = true;
    this.saveClick.emit(this.nameForm.get('name')!.value);
  }

  public cancel(): void {
    this.cancelClick.emit();
  }
}
